<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2">Site information</h1>
  </div>
</div>

<div class="sky-card mt">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">
      <mat-icon>share</mat-icon>
      Sharing
    </h1>
  </div>
  <div class="sky-card-body">
    <div class="container">
      <p>You are free to share any page by copying the URL from the address bar or using the share button in your browser.</p>
      <p>
        Although appreciated, it is <b>not required</b> to credit me (Silverfeelin) when sharing the website.<br/>
        I feel like it'd be slightly dishonest to the other people that have contributed directly or indirectly by only crediting me.<br/>For the people that want to know more about the site, this page exists.
      </p>
    </div>
  </div>
</div>

<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3">
      <mat-icon>note</mat-icon>
      License
    </h2>
  </div>
  <div class="sky-card-body">
    <div class="container ws-pl">
      <p>
        Source code is
        <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/" target="_blank">publicly available on GitHub</a>
        under the
        <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/blob/master/LICENSE" target="_blank">MIT License</a>.
      </p>
      <p>
        This project hosts some media and screenshots captured from the game
        <a class="text-link" href="https://www.thatskygame.com/" target="_blank">Sky: Children of the Light</a>
        developed by
        <a class="text-link" href="https://thatgamecompany.com/" target="_blank">thatgamecompany</a>.<br/>
        Aforementioned license covers which assets are excluded from the terms of the license.
      </p>
      <p>
        Sky Planner is non-commercial, is not affiliated with thatgamecompany and is made available for informational purposes.
      </p>
      <p>
        This project uses many public packages. These are listed in the
        <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/blob/master/package.json" target="_blank">package.json</a>
        file.<br/>
        Package licenses are aggregated in <a class="text-link" href="/3rdpartylicenses.txt">3rdpartylicenses.txt</a>.
      </p>
    </div>
  </div>
</div>

<ng-template #discord>
  <div class="d-inline-block">
    <img class="img-discord" src="assets/external/discord-mark-blue.svg" loading="lazy">
  </div>
</ng-template>

<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3">
      <mat-icon>favorite</mat-icon>
      Attribution
    </h2>
  </div>
  <div class="sky-card-body">
    <div class="container ws-pl">
      <p>
        Thank you kindly for the
        <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/pulls?q=is%3Apr" target="_blank">contributions</a>
        and
        <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/issues?q=is%3Aissue" target="_blank">suggestions</a>
        to improve Sky Planner:<br/>
        Daw, Morybel, oWishy, Gassed1, Plutoy <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/graphs/contributors" target="_blank">and more</a>.
      </p>
    </div>
    <div class="container ws-pl mt">
      <p>
        Various images such as item icons and spirits are loaded directly from the
        <a class="text-link" href="https://sky-children-of-the-light.fandom.com/wiki/Sky:_Children_of_the_Light_Wiki" target="_blank">Sky: Children of the Light Fandom wiki</a>.<br/>
        This project only links to the original assets. For more information refer to
        <a class="text-link" href="https://www.fandom.com/licensing" target="_blank">Fandom licensing page</a>.<br/>
      </p>
      <p class="mb-0">
        A special thanks to the wiki contributors for all their hard work and for giving me permission to show images from the wiki on Sky Planner.
        You can find out more about <a class="text-link" href="https://sky-children-of-the-light.fandom.com/wiki/Special:Community">the wiki contributors here</a>.<br/>
        In particular many icons on the wiki are contributed to the wiki by:
      </p>
      <div class="flex-credits">
        <div class="flex-credit">
          <div class="credit-name">Morybel</div>
          <div class="credit-handle c-accent">
            <ng-container *ngTemplateOutlet="discord"></ng-container>
            <span class="credit-handle-name">morybel</span>
          </div>
        </div>
        <div class="flex-credit">
          <div class="credit-name">Mimi</div>
          <div class="credit-handle c-accent">
            <ng-container *ngTemplateOutlet="discord"></ng-container>
            <span class="credit-handle-name">mimi4117</span>
          </div>
        </div>
        <div class="flex-credit">
          <div class="credit-name">Ray</div>
          <div class="credit-handle c-accent">
            <ng-container *ngTemplateOutlet="discord"></ng-container>
            <span class="credit-handle-name">ray808080</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container ws-pl mt">
      <p>
        Some Traveling Spirit price corrections were made based on infographics by Jed#9275 (new Discord handle unknown).
      </p>
      <p>
        Some YouTube videos by
        <a class="text-link" href="https://www.youtube.com/channel/UCTdBaJiejXA0WSOkPX0YO0w" target="_blank">nastymold</a>,
        <a class="text-link" href="https://www.youtube.com/@noobmode" target="_blank">Noob Mode</a>,
        <a class="text-link" href="https://www.youtube.com/@AppUnwrapper" target="_blank">App Unwrapper</a>
        and
        <a class="text-link" href="https://www.youtube.com/@SkyBat" target="_blank">Sky Bat</a>
        were used as a reference to find missing information for older events.<br/>
        Go check out their content!
      </p>
    </div>
    <div class="container ws-pl mt">
      <p class="mb-0">
        Inspiration and suggestions for the Outfit Request tools by Laila, Morybel, cysketch, rain, luci, kodahonk, ycn, oby and more. Thank you!<br/>
        Backgrounds for the outfit request images generously provided by:
      </p>
      <div class="flex-credits">
        <div class="flex-credit">
          <div class="credit-name">Laila</div>
          <div class="credit-handle c-accent">
            <ng-container *ngTemplateOutlet="discord"></ng-container>
            <span class="credit-handle-name">_laila__</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container ws-pl mt">
      A huge thank you to Stoat, the creator of the Sky Season Calculator and Sky Event Calculator, for the inspiration and being okay with Sky Planner including its own calculators.

      <div class="flex-credits">
        <div class="flex-credit">
          <div class="credit-name">Stoat</div>
          <div class="credit-handle c-accent">
            <ng-container *ngTemplateOutlet="discord"></ng-container>
            <span class="credit-handle-name">.stoat.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container ws-pl mt">
      <p>
        Is your name missing? Please <a class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/issues" target="_blank">open a new Issue on GitHub</a>!
      </p>
  </div>
</div>

<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3">
      <mat-icon>dns</mat-icon>
      Hosting
    </h2>
  </div>
  <div class="sky-card-body">
    <div class="container ws-pl">
      <p>
        Sky Planner is hosted using <a class="text-link" href="https://pages.cloudflare.com/" target="_blank">Cloudflare Pages</a>.<br/>
        <a class="text-link" href="https://www.cloudflare.com/web-analytics/" target="_blank">Cloudflare Web Analytics</a> is enabled and captures anonymous data without tracking you. This allows for insights such as the amount of page visits and the distribution between desktop and mobile visits to help prioritize development.
      </p>
  </div>
</div>
